export const SET_MUSIC_DATA = 'SET_MUSIC_DATA' 

export const SET_CURRENT_SONG_PLAYING = 'SET_CURRENT_SONG_PLAYING'
